/* import __COLOCATED_TEMPLATE__ from './menu-panel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();